import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncUiModel, ReloadVisibility } from './async-ui.model';
import { SuccessDataDirective } from './success-data.directive';

@Component({
  selector: 'uikit-async-ui',
  templateUrl: './async-ui.component.html',
  styleUrls: ['./async-ui.component.scss'],
  providers: [AsyncUiModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsyncUiComponent<T> implements OnChanges, AfterContentInit {
  @ContentChild(SuccessDataDirective) successChild: SuccessDataDirective<T>;
  @Input() data: T;
  @Input() loading: boolean;
  @Input() error: boolean;
  @Input() reloadVisibility: ReloadVisibility = 'data-hidden';
  @Input() loadingMargin = '0';
  @Input() errorMargin = '0';

  /**
   * Internal use only
   */
  readonly _showData$: Observable<boolean> = this.model.showData$;
  readonly _showLoading$: Observable<boolean> = this.model.showLoading$;
  readonly _showError$: Observable<boolean> = this.model.showError$;
  readonly _alternateLoadingVisibility$: Observable<string> = this.model.showAlternateLoading$.pipe(
    map((v) => (v ? 'visible' : 'hidden')),
  );

  constructor(private readonly model: AsyncUiModel) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('data' in changes) {
      this.setDataOnChild(changes['data'].currentValue);
    }
    if ('loading' in changes) {
      this.model.setLoading(changes['loading'].currentValue);
    }
    if ('error' in changes) {
      this.model.setErrored(changes['error'].currentValue);
    }
    if ('reloadVisibility' in changes) {
      this.model.setReloadVisibility(changes['reloadVisibility'].currentValue);
    }
  }

  ngAfterContentInit(): void {
    this.setDataOnChild(this.data);
  }

  private setDataOnChild(data: T): void {
    if (!!this.successChild && !!data) {
      this.successChild.setData(data);
    }
  }
}
